// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container___fas5E {
    display: flex;
    flex-direction: column;
    width: 260px;
    /*width: 15vw;*/
    height: 100%;
    position: fixed;
    left: 0;
    top: var(--navbar-height);
    box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.08);
}

.style__itemContainer___A9Gzu {
    text-decoration: none;
    color: var(--black);
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    padding-left: 15%;
    padding-right: 15%;
    height: 60px;
    margin-top: 1vh;
    transition: background-color 0.3s ease;
    font-size: 18px;
}

.style__itemContainer___A9Gzu:hover {
    background-color: var(--hover-light-color);
}

.style__headerContainer___OI8Qo:hover {
    background-color: transparent;
}

.style__title___wAymm {
    margin-left: 10%;
    font-size: 15px;
}

.style__headerContainer___OI8Qo {
    margin-bottom: 3vh;
}

.style__headerTitle___pvFKb {
    font-size: 20px;
    font-weight: bold;
    color: var(--silver)
}

.style__storageContainer___ZJLvq {
    padding-left: 15%;
    padding-right: 15%;
    margin-top: 28px;
}

.style__storageText___LAuh_ {
    color: var(--black);
    font-size: 15px;
}

.style__upgradeButton___vxTQ3 {
    padding: 8px 50px;
    margin-top: 12px;
}

.style__shieldText___j3XGt {
    font-size: 15px;
    display: flex;
    margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SideBar/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,OAAO;IACP,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,eAAe;AACnB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    width: 260px;\n    /*width: 15vw;*/\n    height: 100%;\n    position: fixed;\n    left: 0;\n    top: var(--navbar-height);\n    box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.08);\n}\n\n.itemContainer {\n    text-decoration: none;\n    color: var(--black);\n    display: flex;\n    align-items: center;\n    width: 100%;\n    box-sizing: border-box;\n    padding-left: 15%;\n    padding-right: 15%;\n    height: 60px;\n    margin-top: 1vh;\n    transition: background-color 0.3s ease;\n    font-size: 18px;\n}\n\n.itemContainer:hover {\n    background-color: var(--hover-light-color);\n}\n\n.headerContainer:hover {\n    background-color: transparent;\n}\n\n.title {\n    margin-left: 10%;\n    font-size: 15px;\n}\n\n.headerContainer {\n    margin-bottom: 3vh;\n}\n\n.headerTitle {\n    font-size: 20px;\n    font-weight: bold;\n    color: var(--silver)\n}\n\n.storageContainer {\n    padding-left: 15%;\n    padding-right: 15%;\n    margin-top: 28px;\n}\n\n.storageText {\n    color: var(--black);\n    font-size: 15px;\n}\n\n.upgradeButton {\n    padding: 8px 50px;\n    margin-top: 12px;\n}\n\n.shieldText {\n    font-size: 15px;\n    display: flex;\n    margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container___fas5E`,
	"itemContainer": `style__itemContainer___A9Gzu`,
	"headerContainer": `style__headerContainer___OI8Qo`,
	"title": `style__title___wAymm`,
	"headerTitle": `style__headerTitle___pvFKb`,
	"storageContainer": `style__storageContainer___ZJLvq`,
	"storageText": `style__storageText___LAuh_`,
	"upgradeButton": `style__upgradeButton___vxTQ3`,
	"shieldText": `style__shieldText___j3XGt`
};
export default ___CSS_LOADER_EXPORT___;
